export default __webpack_public_path__ + "static/media/tech-highlight.01e57e51.svg";